import ActionTypes from "core/actions/actionTypes";
import initialState from "../initialState";

export default function userReducer(user: typeof initialState.user = {} as any, action: any) {
	switch (action.type) {

		case ActionTypes.USER_LOCALE_SET:
			return { ...user, language: action.language, locale: action.locale };

		case ActionTypes.USER_TIMEZONE_SET:
			return { ...user, timeZone: action.timeZone };

		case ActionTypes.USER_ALL_CONDITIONS_SET:
			return {
				...user,
				conditions: action.conditions
			};


		case ActionTypes.USER_CONDITION_SET:
			return {
				...user,
				conditions: {
					...user.conditions || {},
					[action.externalId]: action.value
				}
			};

		default:
			return user;
	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/user/userReducer.ts